import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../firebase';
import CardTemplate from '../components/CardTemplate';
import { CircularProgress } from '@mui/material';

const UserPage = () => {
  const { id } = useParams();
  const [userData, setUserData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;

    const fetchUser = async () => {
      try {
        const userRef = doc(db, 'users', id);
        const userSnap = await getDoc(userRef);

        if (cancelled) return;

        if (userSnap.exists()) {
          setUserData({ id: userSnap.id, ...userSnap.data() });
        } else {
          setError('User not found');
        }
      } catch (err) {
        if (!cancelled) {
          console.error('Error fetching user:', err);
          setError('Failed to load user data');
        }
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    };

    // 10 saniye timeout - fuar WiFi'si yavaşsa takılmasın
    const timeout = setTimeout(() => {
      if (!cancelled) {
        setError('Connection timed out. Please try again.');
        setLoading(false);
      }
    }, 10000);

    fetchUser().then(() => clearTimeout(timeout));

    return () => {
      cancelled = true;
      clearTimeout(timeout);
    };
  }, [id]);

  if (loading) {
    return (
      <div className='loading-container'>
        <CircularProgress />
      </div>
    );
  }

  if (error) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', color: '#fff', fontSize: '18px' }}>
        {error}
      </div>
    );
  }

  return <CardTemplate userData={userData} />;
};

export default UserPage;
